import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
import BillingCycleSwitch from "./BillingCycleSwitch.jsx";

class AdditionalPlans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            billingCycle: "months",
            billingPlans: [],
            dossierSearch: 450,
            searchPerformed: false,
            subscription: null,
            upgradeBillingPlan: false
        };
    }

    componentDidMount() {
        this.getBillingPlans();
    }

    getBillingPlans(billingCycle = "months", dossiers = null) {
        let url = `/api/billing-plans?interval_unit=${billingCycle}&plan_business=true&has_additional_plans=true`;
        if(dossiers !== null) {
            url += `&dossiers=${dossiers}`;
        }
        axios.get(url)
            .then((res) => {
                this.setState({
                    billingPlans: res.data.billingPlans,
                    subscription: res.data.subscription || null,
                    upgradeBillingPlan: res.data.upgradeBillingPlan || false
                });
                console.log('Current subscription:', res.data.subscription);
                console.log('Upgrade billing plan:', res.data.upgradeBillingPlan);
            });
    }

    setBillingCycle(billingCycle) {
        this.setState({ billingCycle }, () => {
            this.getBillingPlans(billingCycle, this.state.searchPerformed ? this.state.dossierSearch : null);
        });
    }

    handleDossierChange = (value) => {
        this.setState({
            dossierSearch: value,
            searchPerformed: true
        }, () => {
            this.getBillingPlans(this.state.billingCycle, value);
        });
    }

    generateHostedPage = (code) => {
        // Check if we need to use PATCH for upgrade or POST for new subscription
        const method = this.state.upgradeBillingPlan ? 'patch' : 'post';
        const url = this.state.upgradeBillingPlan && this.state.subscription ?
                   `/api/zoho/hosted-page/subscriptions/${this.state.subscription.id}` :
                   "/api/zoho/hosted-page/subscriptions";

        axios[method](url, { plan_code: code })
            .then((res) => {
                const { success, data } = res.data;
                if (success && data?.hostedpage?.url) {
                    window.location.href = data.hostedpage.url;
                } else {
                    console.error(
                        "Error: No se encontró la URL de la página alojada."
                    );
                    alert(
                        "No se pudo redirigir a la página de compra. Por favor, intenta nuevamente."
                    );
                }
            })
            .catch((err) => {
                console.error("Error al generar la página alojada:", err);
                alert(
                    "Ocurrió un error al procesar tu solicitud. Por favor, intenta nuevamente."
                );
            });
    };
    render() {
        const { billingPlans, searchPerformed, dossierSearch } = this.state;
        let recommendedPlanIndex = -1;
        if (searchPerformed) {


            let closestPlan = null;
            let smallestDifference = Infinity;

            billingPlans.forEach((plan,index) => {
                const planDifference = Math.abs(plan.limitations[0].limitation_value - dossierSearch);

                // Si encuentras una diferencia más pequeña, actualiza closestPlan
                if (planDifference < smallestDifference) {
                    smallestDifference = planDifference;
                    closestPlan = plan;
                    recommendedPlanIndex = index;
                }
            });
        }

        return (
            <>
            <div className="container mt-5">
                <div className="">
                <h3 className="text-center">Customiza tu plan Business</h3>
                <div className="text-center mt-3">
                    <label htmlFor="expedientes" className="form-label">¿Cuántos expedientes necesitas?</label>
                    <div className="input-group w-50 mx-auto">
                    <input
                        type="number"
                        id="expedientes"
                        className="form-control"
                        value={this.state.dossierSearch}
                        onChange={(e) => this.setState({ dossierSearch: parseInt(e.target.value) || 0 })}
                    />
                    <button
                        className="btn btn-primary"
                        onClick={() => this.handleDossierChange(this.state.dossierSearch)}
                    >
                        Buscar Plan
                    </button>
                    </div>
                </div>

                <BillingCycleSwitch
                    billingCycle={this.state.billingCycle}
                    setBillingCycle={this.setBillingCycle.bind(this)}
                />

                <div className="d-flex justify-content-center filter-buttons">
                    <button className="btn btn-outline-secondary" onClick={() => this.handleDossierChange(250)}>+ 250</button>
                    <button className="btn btn-outline-secondary" onClick={() => this.handleDossierChange(500)}>+ 500</button>
                    <button className="btn btn-outline-secondary" onClick={() => this.handleDossierChange(1000)}>+ 1,000</button>
                    <button className="btn btn-outline-secondary" onClick={() => this.handleDossierChange(2500)}>+ 2,500</button>
                    <button className="btn btn-outline-secondary" onClick={() => this.handleDossierChange(5000)}>+ 5,000</button>
                </div>

                <table className="table mt-4">
                    <thead>
                    <tr>
                        <th>Nombre del Plan</th>
                        <th># Expedientes</th>
                        <th>Almacenamiento</th>
                        <th># Colaboradores</th>
                        <th>Precio</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.billingPlans.map((plan, index) => {
                        const isRecommended = index == recommendedPlanIndex;
                        const isEligible = this.state.upgradeBillingPlan === false ||
                                         (this.state.subscription && plan.id > this.state.subscription.billing_plan_id);

                        // Determine CSS classes based on eligibility
                        const rowClass = isRecommended ? "plan-recommended" : "";
                        const buttonClass = isEligible ? "btn btn-outline-primary" : "btn btn-outline-secondary";

                        return (
                            <tr key={index} className={rowClass}>
                                <td style={{ position: 'relative' }}>
                                    {plan.name}
                                    {isRecommended &&
                                        <span className="badge-recommended">Recomendado</span>}
                                    {!isEligible &&
                                        <span className="badge-unavailable" title="Ya tienes este plan o uno superior">No disponible</span>}
                                </td>
                                <td>{plan.limitations[0].limitation_value}</td>
                                <td>{plan.limitations[1].limitation_value}</td>
                                <td>{plan.limitations[2].limitation_value}</td>
                                <td>${plan.price}</td>
                                <td>
                                    <button
                                        onClick={() => this.generateHostedPage(plan.zoho_plan_code)}
                                        className={buttonClass}
                                        disabled={!isEligible}
                                    >
                                        Contratar
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
                </div>
            </div>
            </>
        );
    }
}

export default AdditionalPlans;

if (document.getElementById("AdditionalPlans")) {
    ReactDOM.render(<AdditionalPlans />, document.getElementById("AdditionalPlans"));
}
